import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import Index from './routes/Index';
import { StrictMode } from 'react';
import ConfigurationBootstrap from './components/ConfigurationBootstrap';
import PhosphorIconInit from "./helper/PhosphorIconInit";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import { getAppBasePath } from "./utils/appUrl";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  useEffect(() => {
    const handleStorage = (event) => {
      if (event.key === 'forceLogout' && event.newValue) {
        window.location.reload();
      }
    };

    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  // const [progress, setProgress] = useState(0)
  return (
    <StrictMode>
      <Provider store={store}>
        <ConfigurationBootstrap>
          <BrowserRouter basename={getAppBasePath() || "/"}>
            <RouteScrollToTop />
            <PhosphorIconInit />
            <Routes>
              <Route path={'*'} element={<Index />} />
            </Routes>
            {/* <Index /> */}
            <ToastContainer />
          </BrowserRouter>
        </ConfigurationBootstrap>
      </Provider>
    </StrictMode>
  );
}

export default App;
